import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import "./home.css";
import SubmitModal from "./submit-modal";
import ShowValue from "../../components/ShowValue";
import ApiNgos from "../../utils/api.ngos";
import ApiAssets from "../../utils/api.assets";
import ApiHallOfFame from "../../utils/api.halloffame";
import Carousel from "./carousel";
import Loading from "../../components/Loading";
import QuantityClassetsModal from "./quantity-classets-modal";

declare var location;
declare var FB;

class HomePage extends Component {
  constructor(props) {
    super(props);

    let data = localStorage.getItem("userData");
    let name, lander_btc_address;

    if (data) {
      let user = JSON.parse(data);
      lander_btc_address = user.lander_btc_address;
      name = user.name.split("");
    }

    this.assetSale = { current: undefined, padding: 0 };
    this.state = {
      ngos: [],
      assets: [],
      classets: [],
      copyAssets: [],
      reservdAssets: [],
      super_landers: [],
      mega_landers: [],
      vip_landers: [],
      best_landers: [],
      flatClassets: [],
      word: "",
      cursor: "",
      lander_btc_address: lander_btc_address,
      modal: false,
      modalClassets: false,
      valueSearch: "",
      key: "",
      collapseGroup: {},
      loading: false,
      loading_tables: false,
      orderByPrice: "0",
      orderByName: "0"
    };

    ApiHallOfFame.get().then(response => {
      if (response.data) {
        const super_landers = response.data.super_landers,
          mega_landers = response.data.mega_landers,
          vip_landers = response.data.vip_landers,
          best_landers = response.data.best_landers;
        this.setState({
          super_landers: super_landers,
          mega_landers: mega_landers,
          vip_landers: vip_landers,
          best_landers: best_landers,
          loading_tables: true
        });
      }
    });

    ApiNgos.getByAmout().then(response => {
      if (response.data) {
        const ngos = response.data.sort((a, b) => a.total_donation > b.total_donation);
        this.setState(...this.state, { ngos: ngos });
      }
    });

    ApiAssets.getOnSale().then(response => {
      let assets;

      if (response.data) {
        assets = response.data;
        assets = this.searchTree(assets, "");
        assets = assets.sort((a, b) => a.order_planets < b.order_planets ? -1 : a.order_planets > b.order_planets ? 1 : 0);
        if (assets) {
          this.setState({
            loading: true,
            assets: assets,
            copyAssets: assets,
            reservdAssets: JSON.parse(JSON.stringify(assets))
          });
        }
      }
      this.flatFunction(this.state.assets);
    });

    this.handleScrollToElement = this.handleScrollToElement.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.collapseToggle = this.collapseToggle.bind(this);
    this.renderLine = this.renderLine.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleSelectOrderByPrice = this.handleSelectOrderByPrice.bind(this);
    this.handleSelectOrderByName = this.handleSelectOrderByName.bind(this);
    this.flatFunction = this.flatFunction.bind(this);
  }

  shareFB(name, assetline) {
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I own an asset at Cryptolands.io! Check this out. The asset name is ${name}!`,
        href: "https://cryptolands.io/assets?assetline=" + assetline
      },
      function (response) { }
    );
  }

  flatFunction(list) {
    let firstFlat = list.flatMap(x => x.child);
    let secondFlat = firstFlat.flatMap(x => x.child);
    let thirdFlat = secondFlat.flatMap(x => x.child);
    let fourthFlat = thirdFlat.flatMap(x => x.child);
    let finalList = [...list, ...firstFlat, ...secondFlat, ...thirdFlat, ...fourthFlat];
    this.setState(...this.state, { flatClassets: finalList });
  }

  handleSelectOrderByName(event) {
    const target = event.target,
      value = target.value;

    this.setState({ orderByName: value });

    let list = [];

    this.state.classets.forEach(classet => {
      list.push(classet);
    });

    switch (value) {
      case "0":
        list = list;
        break;
      case "1":
        list = list.sort((a, b) => a.current_lander < b.current_lander ? -1 : a.current_lander > b.current_lander ? 1 : 0);
        break;
      case "2":
        list = list.sort((a, b) => a.current_lander > b.current_lander ? -1 : a.current_lander < b.current_lander ? 1 : 0);
        break;
      default:
        break;
    }
  }

  handleSelectOrderByPrice(event) {
    const target = event.target,
      value = target.value;

    this.setState({ orderByPrice: value });

    let list = [];

    this.state.classets.forEach(classet => { list.push(classet); });

    switch (value) {
      case "0":
        list = list;
        break;
      case "1":
        list = list.sort((a, b) => a.price > b.price ? -1 : a.price < b.price ? 1 : 0);
        break;
      case "2":
        list = list.sort((a, b) => a.price < b.price ? -1 : a.price > b.price ? 1 : 0);
        break;
      default:
        break;
    }
  }

  searchTree(array, value) {
    array = array.filter(item => {
      if (item.child) {
        item.child.sort((a, b) => a.price < b.price ? -1 : a.price > b.price ? 1 : 0);
        item.child = this.searchTree(item.child, value);
      }

      return (item.current_lander.includes(value) || item.name.includes(value) || item.child.length > 0);
    });

    return array;
  }

  handleInput(event) {
    const target = event.target, value = target.value;
    if (value != "") {
      const assets = this.state.copyAssets;
      let resultFilter = this.searchTree(assets, value);
      this.setState({ assets: resultFilter });
    } else {
      this.setState({
        assets: this.state.reservdAssets,
        copyAssets: this.state.reservdAssets,
        reservdAssets: JSON.parse(JSON.stringify(this.state.reservdAssets))
      });
    }
  }

  handleChange(event) {
    this.setState(...this.state, { valueSearch: event.target.value });
  }

  handleScrollToElement(event, ref) {
    const mainNode = ReactDOM.findDOMNode(this.refs[ref]);
    window.scrollTo(0, mainNode.offsetTop);
  }

  collapseToggle(id) {
    this.setState(...this.state, {
      collapseGroup: {
        ...this.state.collapseGroup,
        [id]: !this.state.collapseGroup[id]
      }
    });
  }

  toggleModalClassets = key => {
    this.setState(...this.state, {
      key: key,
      modalClassets: !this.state.modalClassets
    });
  };

  toggleModal() {
    this.setState(...this.state, { modal: !this.state.modal });
  }

  renderLine(asset) {
    if (asset.asset_line.includes(this.assetSale.current) && window.innerWidth > 768) {
      this.assetSale.padding = 45;
    } else if (asset.asset_line.includes(this.assetSale.current)) {
      this.assetSale.padding = 20;
    } else {
      this.assetSale.current = asset.asset_line;
    }

    return (
      <section className="mt-1" key={asset.asset_line}>
        <div className="row asset-row">
          <div className="col-2">
            <button hidden={!asset.child} className="btn btn-secondary mt-2" onClick={() => this.collapseToggle(asset.asset_line)}>
              <span hidden={this.state.collapseGroup[asset.asset_line]}>
                <i className="fas fa-plus" />
              </span>
              <span hidden={!this.state.collapseGroup[asset.asset_line]}>
                <i className="fas fa-minus" />
              </span>
            </button>
          </div>
          <div className="col-3">
            <img className="d-inline-block mr-2" src={asset.img_url} width="50" />
            <Link to={"/assets?assetline=" + asset.asset_line} className="d-inline-block">
              {asset.name}
            </Link>
          </div>
          <div className="col-2">
            <p className="mt-3">
              Owner: <br /> {asset.current_lander}
            </p>
          </div>

          <div className="col-md-3">
            <p className="pt-2 price-info" hidden={!asset.on_sale}>
              Current Asset Price <br />
              <ShowValue withoutBreak={false} btc={asset.price} />
            </p>
            <p className="pt-3 price-info" hidden={asset.on_sale}>
              Not on sale... yet!
            </p>
          </div>

          <div className="col-md-2">
            <div hidden={asset.owner_address === this.state.lander_btc_address}>
              <Link className="btn btn-outline-success float-right mt-2" hidden={!asset.on_sale} to={"/assets?assetline=" + asset.asset_line + "&buy=true"}>
                Buy now
              </Link>
              <Link className="btn btn-outline-warning float-right mt-2" hidden={!asset.auction || asset.on_sale} to={"/assets?assetline=" + asset.asset_line + "&bid=true"}>
                Make an Offer
              </Link>
            </div>

            <button
              className="btn btn-outline-primary float-right"
              hidden={!this.state.lander_btc_address || !asset.owner_address || asset.owner_address !== this.state.lander_btc_address}
              onClick={this.shareFB}
            >
              <i className="fab fa-facebook-f" />
              Share
            </button>
          </div>
        </div>

        <Collapse style={{ paddingLeft: this.assetSale.padding }} isOpen={this.state.collapseGroup[asset.asset_line]}>
          {this.hasChild(asset)}
        </Collapse>
      </section>
    );
  }

  hasChild(asset) {
    if (asset.child) {
      return asset.child.map(subasset => this.renderLine(subasset));
    }
  }

  render() {
    return (
      <div className="homepage">
        <Carousel handleScrollToElement={this.handleScrollToElement} />
        <section className="hallOfFame-section" ref="hallOfFame">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <h3 className="section-title">Hall of Fame</h3>
                    <br />
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row justify-content-center">
                      <div className="col-md-6">
                        <h5 className="section-title">Super Landers</h5>
                        <p className="section-subtitle">
                          Cryptolanders with most Classets.
                        </p>
                        <div hidden={this.state.loading_tables}>
                          <img className="d-block m-auto loading-img pb-1" width="50" src="/assets/images/loading.gif" alt="loading icon" />
                          <p className="text-center text-primary">
                            Loading Super Landers
                          </p>
                        </div>
                        <table hidden={!this.state.loading_tables} className="table table-bordered table-super-lander">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th className="text-left" scope="col">Cryptolander</th>
                              <th scope="col">Classets</th>
                              {/* <th scope="col"></th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.super_landers.map((item, index) => {
                              const path_image = `assets/images/medal-${index}.svg`;
                              return (
                                <tr>
                                  <th scope="col" hidden={index > 2}>
                                    <img className="medal" src={path_image} />
                                  </th>
                                  <th scope="col" hidden={index <= 2}>{`${index + 1}°`}</th>
                                  <td className="text-left">{item.name}</td>
                                  <td>
                                    <p onClick={e => {
                                      if (item.name) {
                                        const itens = this.state.flatClassets;
                                        if (itens) {
                                          const resultFilter = this.searchTree(itens, item.name);
                                          this.handleScrollToElement(e, 'assets')
                                          this.setState({ assets: resultFilter, valueSearch: item.name });
                                        }
                                      } else {
                                        this.setState({
                                          assets: this.state.reservdAssets,
                                          copyAssets: this.state.reservdAssets,
                                          reservdAssets: JSON.parse(JSON.stringify(this.state.reservdAssets))
                                        });
                                      }
                                    }}>{item.quantity_classets}</p>
                                  </td>
                                  {/* <td>
                                    <span onClick={() => { this.toggleModalClassets(item.key) }}><i class="fas fa-eye"></i></span>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="col-md-6">
                        <h5 className="section-title">Vip Landers</h5>
                        <p className="section-subtitle">
                          Cryptolanders with most valuable classet.
                        </p>
                        <div hidden={this.state.loading_tables}>
                          <img className="d-block m-auto loading-img pb-1" width="50" src="/assets/images/loading.gif" alt="loading icon" />
                          <p className="text-center text-primary">
                            Loading Vip Landers
                          </p>
                        </div>
                        <table hidden={!this.state.loading_tables} className="table table-bordered table-vip-lander">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th className="text-left" scope="col">Cryptolander</th>
                              <th className="text-left" scope="col">Classet </th>
                              <th scope="col" />
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.vip_landers.map((item, index) => {
                              const path_image = `assets/images/medal-${index}.svg`;
                              const path_url = `/assets/?assetline=${item.access_url}`;
                              return (
                                <tr>
                                  <th scope="col" hidden={index > 2}>
                                    <img className="medal" src={path_image} />
                                  </th>
                                  <th scope="col" hidden={index <= 2}>{`${index + 1}°`}</th>
                                  <td className="text-left">{item.owner}</td>
                                  <td className="text-left">
                                    <Link to={path_url}>
                                      {item.name}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link to={path_url}>
                                      <img className="classet-image" src={item.image_url} />
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <img className="arrow-down mt-5" src="assets/images/down.gif" onClick={e => this.handleScrollToElement(e, "assets")} />
              </div>
            </div>
          </div>
        </section>
        {/* {Hall of Fame} */}
        <section className="home-section" ref="assets">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row justify-content-center">
                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <h3 className="section-title">Explore Classets</h3>
                    <p className="section-subtitle">
                      Browse thru available classets
                    </p>
                  </div>
                  <div className="col-lg-7 col-md-7 col-sm-12">
                    <input className="input-search" type="text" placeholder="Search Lander or Classet Name" onInput={this.handleInput} onChange={this.handleChange} value={this.state.valueSearch} />
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="panel">
                    <div hidden={this.state.loading}>
                      <img className="d-block m-auto loading-img pb-1" width="50" src="/assets/images/loading.gif" alt="loading icon" />
                      <p className="text-center text-primary">Loading Classets</p>
                    </div>
                    {this.state.assets.map((asset, index) => this.renderLine(asset))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>{" "}
        {/* Explore Classets */}
        <hr />
        <main className="main-content" ref="main">
          <section className="home-section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <h3 className="section-title">How it Works</h3>
                  <p className="section-subtitle">Easy and simple rules</p>
                  <div className="panel">
                    <p>
                      1 - Choose any available "Classet" you like. A "Classet"
                      is a "Cryptolands Asset".
                      <br />
                      <br />
                      2 - When you buy a Classet, a substantial part of it is a
                      donation for your chosen a Cause.
                      <br />
                      <br />3 - Anyone can buy your Classet from you at anytime.{" "}
                      <br />
                      <br />
                      4 - Immediately after you buy, your Classet will be put on
                      sale for a higher price.
                      <br />
                      <br />5 - You'll have to set up the price increase, from
                      60% to 100%.
                      <br />
                      <br />
                      6 - "Confirm buy" and became a proud "Cryptolander".
                      <br />
                      <br />
                      7 - When (and if) someone buys your Classet, you earn a
                      fixed 20% profit.
                      <br />
                      <br />
                      8 - 10% Dividends are distributed among other "landers".
                      <br />
                      <br />
                      9 - Cryptolands.io platform also gets 10% contribution.
                      <br />
                      <br />
                      10 - The largest remaining chunk (20%-60%) will be donated
                      to the chosen a Cause.
                      <br />
                      <br />
                      Just Remember: You are here to donate, invest and have
                      fun.
                      <br />
                      <br />
                    </p>
                    <p className="disclaimer-text">
                      <span className="disclaimer-title">Disclaimer: </span> <b>Cryptolands.io</b> is a fictional game and does not grant any real-estate rights of any kind. By accessing the platform you confirm having understood the purpose of the game and its terms and conditions.
                    </p>
                  </div>
                </div>
                <div className="col-md-12">
                  <img className="arrow-down mt-5" src="assets/images/down.gif" onClick={e => this.handleScrollToElement(e, "ngos")} />
                </div>
              </div>
            </div>
          </section>{" "}
          {/* How it Works */}
          <section className="home-section" ref="ngos">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <h3 className="section-title">Participating Causes </h3>
                  <p className="section-subtitle">The benefit we bring</p>
                  {this.state.ngos.map((ngo, index) => (
                    <div className="panel">
                      <div className="row">
                        <div className="col-md-2">
                          <img className="img-fluid d-block m-auto" src={ngo.image} />
                        </div>
                        <div className="col-md-4">
                          <p className="panel-text">
                            {ngo.name} <br />
                            <ShowValue btc={ngo.total_donation} />
                          </p>
                        </div>
                        <div className="col-md-3">
                          <a target="_blank" href={ngo.url_link} className="btn btn-outline-light btn-block">
                            Visit the web site
                          </a>
                        </div>
                        <div className="col-md-3">
                          <a target="_blank" href={"https://blockchain.info/pt/address/" + ngo.ngo_btc_address} className="btn btn-outline-light btn-block">
                            Check the Blockchain
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button className="btn btn-cta text-center" onClick={this.toggleModal}>
                    Submit a Cause
                  </button>
                </div>
              </div>
            </div>
          </section>{" "}
          {/* NGOS */}
          <hr />
        </main>
        <SubmitModal isOpen={this.state.modal} toggle={this.toggleModal} />
        {/* <QuantityClassetsModal
          isOpen={this.state.modalClassets}
          toggleModalClassets={this.toggleModalClassets}
          idKey={this.state.key}
        /> */}
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js